import React from 'react'
import { useTranslation } from 'react-i18next'

export default function Partenaires(){
  const { t } = useTranslation()
  const partners = [t('partners.banks'), t('partners.notaries'), t('partners.agencies'), t('partners.developers'), t('partners.artisans'), t('partners.insurers')]
  return (
    <section className="section">
      <div className="container mx-auto px-4">
        <h2 className="section-title" dangerouslySetInnerHTML={{ __html: t('partners.title') }} />
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-3">
          {partners.map((p,i)=>(
            <div key={i} className="card text-center py-6 font-bold">{p}</div>
          ))}
        </div>
      </div>
    </section>
  )
}
